import React, { useContext } from "react";
import { boostProductTierConfig } from "components/Pages/Boost/consts";
import { MobileContext } from "components/common";
import { LEGAL_LINK_TYPES, LegalLink } from "components/common/LegalLink";

const legalLinkClassNames =
  "py-1 px-4 text-sm text-boost-primary hover:text-boost-primary text-center underline hover:underline hover:text-boost-light-purple";

const BoostMembership = ({ user }) => {
  const { isMobile } = useContext(MobileContext);
  const { boost } = user;
  const { productTier, productTerm = "monthly" } = boost;
  const currentTierConfig =
    boostProductTierConfig[productTerm]?.[productTier] || {};

  const listStyle = {
    listStyleType: "circle",
    ...(!isMobile && { listStylePosition: "inside" }),
  };

  const getList = () => {
    return currentTierConfig.perks.map((p) => {
      return (
        <li key={p.substring(5)} style={listStyle}>
          {p}
        </li>
      );
    });
  };

  return (
    <div
      className={`mt-4 w-full inline-grid ${
        isMobile ? "justify-items-center" : "justify-items-start"
      }`}
    >
      <div>
        <ul>{getList()}</ul>
      </div>
      <div className="text-xxs py-2">
        <p>{`* The minimum reported is $${currentTierConfig.minLine} and you can increase it by matching utilities. Positive history will always be reported.`}</p>
      </div>
      <div className="mt-4 w-full">
        <div
          className={`flex flex-col sm:flex-row w-full space-x-0 sm:space-x-4 space-y-4 sm:space-y-0 ${
            isMobile ? "flex-col space-y-4" : ""
          }`}
        >
          <LegalLink
            type={LEGAL_LINK_TYPES.PRIVACY_POLICY}
            className={legalLinkClassNames}
          />
          <LegalLink
            type={LEGAL_LINK_TYPES.TERMS_AND_CONDITIONS}
            className={legalLinkClassNames}
          />
        </div>
      </div>
    </div>
  );
};

export default BoostMembership;
